import { DISMISS_NEW_YEAR_ALERT } from './ActionTypes';
import { setNewYearAlertDismissedStorageValue } from '../utils/alertsUtils';
export function dismissNewYearAlert(currentYear) {
  return dispatch => {
    setNewYearAlertDismissedStorageValue(currentYear);
    dispatch({
      type: DISMISS_NEW_YEAR_ALERT
    });
  };
}